import { IconButton, Inline, Modal, Typography } from '@airbus/components-react';
import GridTable from '../../../shared/components/grid/GridTable';
import useFetchScreenDetails from '../../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider from '../../../shared/context/GetAllColumnContext';
import { Close } from '@airbus/icons/react';
import styles from './FinancialRepositoryGridTables.module.css';
import { t } from 'i18next';

type FinancialRepositoryGridTablesProps = {
  open: boolean;
  setOpen: (v: boolean) => void;
  value: any;
  language: string;
  inlineMode?: boolean;
};

export const FinancialRepositoryGridTables = ({
  open,
  setOpen,
  value,
  inlineMode = false,
}: FinancialRepositoryGridTablesProps) => {
  const { screenTables } = useFetchScreenDetails('finance_repository');

  const tableName =
    value?.featureName === 'config_fin_repo' ? 'tblopt_finrepoconfig' : 'tblopt_finrepoprogfee';

  const tableRes = screenTables?.find((item) => item.mbdDataGrid.dataGridInternalName == tableName);

  if (inlineMode) {
    return (
      <div className={styles.contentSection}>
        {!screenTables ? null : (
          <GetAllColumnContextProvider>
            <GridTable tableRes={tableRes} />
          </GetAllColumnContextProvider>
        )}
      </div>
    );
  }

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div className={styles.modal}>
        <Inline alignY='center' align='space-between' spacing='quarter-x'>
          <Typography variant='h6'>{t(`header_actions.${value?.featureName}`)}</Typography>
          <IconButton
            variant='ghost'
            onClick={() => {
              setOpen(false);
            }}
            className={styles.closeBtnContainer}
          >
            <Close className={styles.closeButton} />
          </IconButton>
        </Inline>
        {!screenTables ? null : (
          <GetAllColumnContextProvider>
            <GridTable tableRes={tableRes} />
          </GetAllColumnContextProvider>
        )}
      </div>
    </Modal>
  );
};
